module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/smoothie@3x_6386ea.jpg";